<template lang="pug">
.page-footer
  .footer-top
    .product_column.footer_column
      .column_title {{ $t('产品') }}
      .column_items
        .column_item(
          v-for="item in products"
          @click="navTo(item.link)"
        ) {{ item.name }}
    .service_column.footer_column
      .column_title {{ $t('服务') }}
      .column_items
        .column_item(
          v-for="item in services"
          @click="navTo(item.link)"
        ) {{ item.name }}
    .about_column.footer_column
      .column_title {{ $t('关于复歌') }}
      .column_items
        .column_item(
          @click="$router.push('/about')"
        ) {{ $t('关于复歌') }}
    .contcat_column.footer_column
      .column_title {{ $t('联系方式') }}
      .column_items
        .column_item 021-62583355
        .column_item client@fugetech.com
        .column_item 上海市静安区<br>威海路511号1403室
    .qrCode_column.footer_column
      .qrCode_column__content.new_qrCode(style='justify-content: flex-start;padding-left: 13px;')
        .qrCode_weChat_conten
          img(
            src="@/assets/wechat-qrcode.png"
          )
          span {{ $t('扫码关注我们') }}
      .qrCode_column__content.new_qrCode
        .qrCode_weChat_conten
          img(
            src="@/assets/qrCode1.png"
          )
          span {{ $t('好快活 | 人才情报局') }}
        .qrCode_weChat_conten
          img(
            src="@/assets/qrCode2.png"
          )
          span {{ $t('好快活 | 名人榜') }}
  .copyright-container
    div © All rights reserved 2009-{{new Date().getFullYear()}}.FugeTech,Inc.
    a(style="margin-left: 10px;color:#acadb9" href="https://beian.miit.gov.cn") 沪ICP备10009106号-1
</template>

<script>
export default {
  data () {
    return {
      products: [
        {
          name: '好快活',
          link: '/product/happy'
        },
        {
          name: 'Libra',
          link: '/product/libra'
        },
        {
          name: 'Bid Agent',
          link: '/product/bid_agent'
        },
        {
          name: 'Rimix',
          link: '/product/rimix'
        },
        {
          name: 'Data Hub',
          link: '/product/data_hub'
        },
        {
          name: '贵了么',
          link: '/product/guileme'
        },
        {
          name: 'iMedia Matrix',
          link: '/product/i_media_matrix'
        },
        {
          name: 'iMedia Tracker',
          link: '/product/i_media_tracker'
        },
        
      ],
      services: [
        {
          name: '营销人才服务',
          link: '/service/financial-service?activeIndex=0'
        },
        {
          name: '广告运营',
          link: '/service/ad-marketing?activeIndex=0'
        },
        {
          name: '资源直采',
          link: '/service/resource-purchasing'
        },
        {
          name: '媒体审计',
          link: '/service/price-auditing'
        },
        {
          name: '数字化管理',
          link: '/service/digital-management'
        },
        {
          name: '效果评估',
          link: '/service/effect-evaluation'
        }
      ]
    }
  },
  methods: {
    navTo (link) {
      this.$router.push(link)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="stylus">
.page-footer
  .footer-top
    display flex
    padding-left 120px
    padding-right 120px
    margin-top 30px
    margin-bottom 50px
    margin-left auto
    justify-content space-around
  // .el-row
  //     margin-top 20px
  //     margin-bottom 20px
  // .footer__left__title
  //     color $black-title
  //     font-weight 600
  //     .el-col
  //         font-size 18px
  // .footer__left__divider
  //     width 699px
  //     height 1px
  //     border none
  //     border-top solid 1px rgba(48, 50, 81, 0.15);
  // .footer__left__content
  //     .el-col
  //         font-size 18px
  //         color rgba(48, 50, 81, 0.81)
  //         cursor pointer
  // .footer__right
  //     display flex
  //     .footer__right__content
  //         text-align center
  //         img
  //             width 150px
  //             height 150px
  //         span
  //             margin-top 20px
  //             font-size 18px
  //             color $black-title
  //             display block
  .footer_column
    width 200px
    .column_title
      font-size 18px
      font-weight 600
      color #303251
      padding-bottom 16px
      margin-bottom 16px
      border-bottom 1px solid rgba(48, 50, 81, 0.15)
      width 142px
    .column_items
      .column_item
        font-size 16px
        color #6e6f85
        margin-bottom 16px
        cursor pointer
        width 300px
      .column_item:hover
        text-decoration underline
    .qrCode_column__content
      // width: 50%
      margin-top 30px
      text-align center
      img
        width 100px
        height 100px
      span
        margin-top 16px
        font-size 16px
        min-width 120px
        color #6e6f85
        display block
    .new_qrCode
      display: flex
      justify-content: space-between

  .contcat_column
    width 200px
    .column_items .column_item:hover
      text-decoration none
      cursor auto
  .qrCode_column
    width: 300px
    padding-top 20px
  .copyright-container
    background-color #f7f8f9
    height 65px
    color #acadb9
    justify-content: center;
    display: flex;
    align-items: center;
    font-size 16px
</style>
